import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { toVehicleMarker } from './vehicle.mapper';
import { getVehiclesList } from './vehicle.query';
import { useDashboardConfig } from '../../hooks';
import { notificationsConfig } from '../../config/constants';
import { useLastVehiclePositionSubscription } from './vehicles.subscription';
export const useMarkersQuery = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { RESOURCES_BASE_URL } = useDashboardConfig();
    const getVehicleIcon = (icon) => `${RESOURCES_BASE_URL}/assets/images/fleet/asset-icons/${icon}.svg`;
    const vehiclesQuery = useQuery({
        queryKey: ['markers'],
        queryFn: () => getVehiclesList(),
        select: (data) => data === null || data === void 0 ? void 0 : data.map(toVehicleMarker).map((vehicle) => ({ ...vehicle, icon: getVehicleIcon(vehicle.icon) })),
        refetchOnWindowFocus: false,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget::cant_load_vehicle_list',
        })),
    });
    const updateVehiclePosition = (lastVehiclePositions) => {
        const markers = queryClient.getQueryData(['markers']) || [];
        const markerArr = [...markers];
        lastVehiclePositions.forEach((change) => {
            const vehicle = markerArr.findIndex((m) => m.id === change.vehicleId);
            if (vehicle > -1 && change.vehicleGps.gps.position) {
                markerArr[vehicle] = {
                    ...markerArr[vehicle],
                    color: change.vehicleStatus ? `#${change.vehicleStatus.color}` : '#FFF',
                    coordinates: [change.vehicleGps.gps.position.coordinates[1], change.vehicleGps.gps.position.coordinates[0]],
                };
            }
        });
        queryClient.setQueriesData(['markers'], markerArr);
    };
    useLastVehiclePositionSubscription({
        vehicleIds: vehiclesQuery.data ? vehiclesQuery.data.map((v) => v.id) : [],
        onChange: (lastVehiclePositions) => {
            updateVehiclePosition(lastVehiclePositions);
        },
        onMissingVehicleUpdate: () => {
            vehiclesQuery.refetch();
        },
    });
    return vehiclesQuery;
};
//# sourceMappingURL=useMarkersQuery.js.map